// @flow

import React from 'react'
import { connect } from 'react-redux'
import { translate } from '../../helpers/global'
import AstrntLogoWhite from '../../styles/img/astro-logo-white.svg?v=1'

type Props = {
  globalGetLanguages: string
};

const FooterClean = ({ globalGetLanguages }: Props) => {
  return (
    <footer>
      <section className="footer-clean">
        <div>
          © Astronaut Technologies Pte Ltd. All rights reserved.
        </div>
		<ul className="for-soc">
			<li>
			<a href="https://www.facebook.com/astrnt.co" target="_blank" rel="noopener noreferrer">
				<i className="fab fa-facebook" />
			</a>
			</li>
			<li>
			<a href="https://www.youtube.com/c/astrntco" target="_blank" rel="noopener noreferrer">
				<i className="fab fa-youtube" />
			</a>
			</li>
			<li>
			<a href="https://www.linkedin.com/company/astrnt-co" target="_blank" rel="noopener noreferrer">
				<i className="fab fa-linkedin" />
			</a>
			</li>
			<li>
			<a href="https://www.instagram.com/astrnt.co/" target="_blank" rel="noopener noreferrer">
				<i className="fab fa-instagram" />
			</a>
			</li>
		</ul>
      </section>
    </footer>
  )
}

const mapStateToProps = (state) => {
  return {
    globalGetLanguages: state.globalGetLanguages,
  }
}

export default connect(mapStateToProps, null)(FooterClean)